define( [
	"../var/support"
], function( support ) {

support.focusin = "onfocusin" in window;

return support;

} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/event/support.js
 ** module id = 883
 ** module chunks = 2
 **/